import { measuredUsingConfigFor as wrap, mergeConfig } from 'Components/Worksheets/Core/Helpers/configHelpers';
import getDerivedFromMeasurementsConfig from 'Components/Worksheets/OversizeCorrectionWorksheet/derivedFromMeasurementsConfig';
import qestIds from '../../../QestIds';

const densityProps = { uom: 'lb/ft³', format: { nearest: 0.1 } };
const moistureContentProps = { format: { nearest: 0.1 } };
const oversizeProps = { format: { nearest: 1 } };

const getConfig = (prefix: string) =>
  mergeConfig(
    {
      [`${prefix}.MaximumDryDensity`]: densityProps,
      [`${prefix}.OptimumMoistureContent`]: moistureContentProps,
      [`${prefix}.LaboratoryDeterminedOversize`]: oversizeProps,
      [`${prefix}.OversizeSpecificGravity`]: { format: { nearest: 0.001 } },
      [`${prefix}.FieldOversize`]: oversizeProps,
      [`${prefix}.Results.CorrectedMaximumDryDensity`]: densityProps,
      [`${prefix}.Results.CorrectedOptimumMoistureContent`]: moistureContentProps,
    },
    getMeasuredUsingConfig(prefix),
    getDerivedFromMeasurementsConfig(prefix),
    {
      [`${prefix}.Balance`]: { defaultReadability: 1, defaultUom: 'g' },
    }
  );

const getMeasuredUsingConfig = (prefix: string) => {
  const balance = wrap(`${prefix}.Balance`);
  return {
    [`${prefix}.TareMass`]: balance,
    [`${prefix}.SoilRockAndTareMass`]: balance,
    [`${prefix}.TareAndRockMass`]: balance,
  };
};

export { getConfig };

export default {
  [qestIds.oversizeCorrection.ARIZ_227e]: getConfig,
};
